var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCode3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.4265,
    y: 32.3509,
    width: 20.9466,
    height: 21.0149,
    rx: 10.4733,
    fill: "black",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.5984 40.1567C90.0085 40.1567 87.0984 37.2466 87.0984 33.6567L87.0984 25.306L101.9 25.306L101.9 33.6567C101.9 37.2466 98.9898 40.1567 95.3999 40.1567L93.5984 40.1567Z",
    fill: "black",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7968 118.649C67.3866 118.649 70.2968 121.559 70.2968 125.149L70.2968 132.619L56.3731 132.619L56.3731 125.149C56.3731 121.559 59.2832 118.649 62.8731 118.649L63.7968 118.649Z",
    fill: "black",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9265 118.649C30.5164 118.649 33.4265 121.559 33.4265 125.149L33.4265 132.619L19.5028 132.619L19.5028 125.149C19.5028 121.559 22.413 118.649 26.0029 118.649L26.9265 118.649Z",
    fill: "black",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.625 48.627C132.625 52.2169 129.715 55.127 126.125 55.127L118.701 55.127L118.701 41.1569L126.125 41.1569C129.715 41.1569 132.625 44.067 132.625 47.6569L132.625 48.627Z",
    fill: "black",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7968 101.799C74.2069 101.799 71.2968 98.8885 71.2968 95.2986L71.2968 94.3285C71.2968 90.7386 74.2069 87.8285 77.7968 87.8285L86.0983 87.8285L86.0983 101.799L77.7968 101.799Z",
    fill: "black",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.9 47.6567C102.9 44.0669 105.81 41.1567 109.4 41.1567H117.701V55.1269H102.9V47.6567Z",
    fill: "black",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7968 117.649C74.2069 117.649 71.2968 114.739 71.2968 111.149L71.2968 109.298C71.2968 105.709 74.2069 102.798 77.7968 102.798L86.0983 102.798L86.0983 117.649L77.7968 117.649Z",
    fill: "black",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3999 71.9775C98.9897 71.9775 101.9 74.8876 101.9 78.4775L101.9 86.8282L87.0984 86.8282L87.0984 78.4775C87.0984 74.8876 90.0085 71.9775 93.5984 71.9775L95.3999 71.9775Z",
    fill: "black",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.558 124.268C103.558 120.679 106.468 117.768 110.058 117.768H117.482V133.5H110.058C106.468 133.5 103.558 130.59 103.558 127V124.268Z",
    fill: "black",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2834 93.4478C19.2834 89.8579 22.1936 86.9478 25.7834 86.9478H33.2071V102.679H25.7834C22.1936 102.679 19.2834 99.7689 19.2834 96.1791V93.4478Z",
    fill: "black",
    stroke: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.9 56.127H117.701V64.4778C117.701 68.0676 114.791 70.9778 111.201 70.9778H109.4C105.81 70.9778 102.9 68.0676 102.9 64.4778V56.127Z",
    fill: "black",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0984 117.649L87.0984 102.798L101.9 102.798L101.9 111.149C101.9 114.739 98.9898 117.649 95.3999 117.649L87.0984 117.649Z",
    fill: "black",
    stroke: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.9 101.799L87.0984 101.799L87.0984 87.8285L101.9 87.8285L101.9 101.799Z",
    fill: "black",
    stroke: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M132.406 127C132.406 130.59 129.495 133.5 125.906 133.5L118.482 133.5L118.482 117.769L125.906 117.769C129.495 117.769 132.406 120.679 132.406 124.269L132.406 127Z",
    fill: "black",
    stroke: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0085 96.1793C49.0085 99.7691 46.0984 102.679 42.5085 102.679L33.3292 102.679L33.3292 86.9479L42.5085 86.9479C46.0984 86.9479 49.0085 89.8581 49.0085 93.4479L49.0085 96.1793Z",
    fill: "black",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.125,
    y: 21,
    width: 43.5496,
    height: 43.7164,
    rx: 11,
    stroke: "black",
    strokeWidth: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode3);
export default __webpack_public_path__ + "static/media/qr-code-3.72f5fba902c7c84465c49952ea145a87.svg";
export { ForwardRef as ReactComponent };